<template>
  <el-aside v-if="currentProject" class="hidden-sm-and-down" :style="asideStyle">
    <DeviceMenus
      v-if="showDeviceMenus"
      v-show="!isfold"
      :device="device"
      :draggable="currentAdminIsSuper"
      @nodeDrop="nodeDrop">
    </DeviceMenus>
    <div class="sidebar-toggle">
      <div @click="toggleSidebar"><i :class="foldIconClass"></i></div>
    </div>
  </el-aside>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DeviceMenus from '@/components/menus/DeviceMenus';

export default {
  components: {
    DeviceMenus,
  },
  inject: ['checkPageReady'],
  data() {
    return {
      isfold: false,
      showDeviceMenus: false,
      device: null,
    };
  },
  computed: {
    ...mapState('project', ['currentProject']),
    ...mapGetters('admin', ['currentAdminIsSuper']),
    asideStyle() {
      return this.isfold ? { width: '30px' } : { width: 'initial' };
    },
    foldIconClass() {
      return this.isfold ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left';
    },
  },
  mounted() {
    this.onPageReady();
    window.addEventListener('resize', () => {
      this.$bus.$emit('RESIZE_WINDOW');
    }, false);
  },
  methods: {
    async onPageReady() {
      // 带deviceId时的处理
      const deviceName = this.$route.params.deviceId;
      if (deviceName) {
        this.device = await this.$store.dispatch('device/findOrGetDevice', { deviceName });
        this.$store.commit('menu/setCurrentDevice', this.device);
      }

      this.showDeviceMenus = true;
    },
    nodeDrop(branches) {
      this.$store.commit('group/setBranches', { branches });
    },
    toggleSidebar() {
      this.isfold = !this.isfold;
      setTimeout(() => {
        this.$bus.$emit('RESIZE_WINDOW');
      }, 50);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/variables';

.el-aside {
  display: flex;
  position: relative;
  .sidebar-toggle {
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    div {
      cursor: pointer;
      flex: 1;
      padding: 5px 0px;
      border-radius: 1px;
      background: $blue;
      color: white;
      font-size: 16px;
      text-align: center;
    }
  }
}
</style>
